export enum TariffOptionsActivationTypes {
  DISPATCHER = 'DISPATCHER',
  USSD = 'USSD',
  SMS = 'SMS',
  ADDON = 'ADDON',
}
